import store from '@/store/index';
let state = store.state.card;
function calcOffsetXFromParent(e) {
  function getStyleByValue(el, val) {
    return ((el && window.getComputedStyle(el)) || el.currentStyle)[val];
  }
  var el = e.target || e.srcElement;
  var elParent = el.parentNode;
  if (el && elParent) {
    return (
      el.getBoundingClientRect().left -
      elParent.getBoundingClientRect().left +
      e.offsetX +
      parseFloat(getStyleByValue(el, 'borderLeftWidth')) -
      parseFloat(getStyleByValue(elParent, 'borderLeftWidth'))
    );
  } else {
    console.error('el或者elParent 未知错误');
    return (
      e.offsetX +
      parseFloat(getStyleByValue(el, 'borderLeftWidth')) -
      parseFloat(getStyleByValue(elParent, 'borderLeftWidth'))
    );
  }
}
function calcOffsetYFromParent(e) {
  function getStyleByValue(el, val) {
    return (window.getComputedStyle(el) || el.currentStyle)[val];
  }
  var el = e.target || e.srcElement;
  var elParent = el.parentNode;

  return (
    el.getBoundingClientRect().top -
    elParent.getBoundingClientRect().top +
    e.offsetY +
    parseFloat(getStyleByValue(el, 'borderTopWidth')) -
    parseFloat(getStyleByValue(elParent, 'borderTopWidth'))
  );
}
/**
 * 通过回调方法通知需要的对象
 * 只涉及到计算数据部分
 */
const BORDER_HEIGHT = 1; // 每个编辑器的border高度为1px
const MARGIN_TOP = 10; // 每道大题之间的margintop值为10px
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
const WRAP_CONTENT_CLASS = '.wrapper-content'; // wrapper_content的class
const TOPIC_BOX_CLASS = '.topic-box'; // topic-box的class
const CHOOSE_CONT_CLASS = 'choose-cont-hastitle'; //选做题的class
const NONANSWER_CLASS = 'non-answer-area'; // 非答题区域class
const TAG_NAME_TABLE = 'TABLE';
// const TAG_P_HEIGHT = 54; // 一个p元素的固定高度
import { TAG_P_HEIGHT } from '@/subjects/constant';
export default class MyDrag {
  currentPage = 0; // 当前是第几页（如在页面一的下表就是1）层级相对于页面
  currentIndexInPages = 0; // 当前在总页面的拖拽下标（如在页面二的下标1）层级相对于题型
  currentIndexInSubjects = 0; // 当前在本题型的拖拽下标（如在题型二中下标3）层级相对于题型跨页分解
  options = undefined; // 外部属性
  target = undefined; //拖拽存在目标元素集合
  currentTarget = undefined; //d当前拖拽目标元素集合
  startX = 0; // 距离当前定位的元素鼠标按下当前x轴的距离
  startY = 0; // 距离当前定位的元素鼠标按下当前x轴的距离
  moveX = 0; // 距离当前定位的元素鼠标移动时当前x轴的距离
  moveY = 0; // 距离当前定位的元素鼠标移动时当前x轴的距离
  endX = 0; // 距离当前定位的元素鼠标松开当前x轴的距离
  endY = 0; // 距离当前定位的元素鼠标松开当前y轴的距离
  moveDirection = 'up'; // 鼠标移动方向 uo向上拖拽 down向下
  moveDistance = 0; // 鼠标拖拽的距离
  currentExistHeight = 0; // 拖拽时当前纸张已经存在的累加高度
  targetBeforeMoveHeight = 0; // 鼠标移动前 当前元素的高度
  overstepDistance = 0; // 鼠标移动当前元素大于一页最高高度超出的部分
  store = undefined; // 赋值全局vuex store
  cardState = undefined; //card state
  mouseDownCount = 0;
  moveMinDistance = 0;
  cacheClientY = 0;
  isGetMinDistance = false;
  canFillHeight = 0; // 当前纸张剩余可填充高度
  constructor(target,canFillHeight) {
    this.target = Array.from(target); // nodelist类数组转化为真实数组
    this.canFillHeight = canFillHeight;
  }

  /**
   * 初始化拖拽方法
   * @param {*} options 初始化需要的参数
   * @returns {void}
   * useDragButton = true; //默认只在拖拽工具上面操作
   */
  init(options) {
    this.options = options;
    this.dragStart(options);
  }

  /**
   * 初始化vuex的store
   * @param {Store} store vuex的store
   * @returns {void}
   */
  initVuexStore(store) {
    this.store = store;
    this.cardState = store.state.card;
  }

  /**
   * 鼠标按下
   * @param {object} options 外部传入的拖拽可选项（如是否通过拖拽器拖拽
   * @returns {void}
   */
  dragStart(options) {
    options.useDragButton
      ? this.dragStartWithButton(options.canDragArea)
      : this.dragStartWithoutAny();
  }

  /**
   * 鼠标拖拽范围元素所有
   */
  dragStartWithoutAny() {
    this.target.forEach(targetItem => {
      targetItem.addEventListener('mousedown', e => {
        e = event || ev;
        e.stopPropagation();
        this.targetBeforeMoveHeight = targetItem.parentNode.offsetHeight;
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.onmousemove(targetItem);
      });
    });
  }

  /**
   * 鼠标可拖拽自定义范围（默认使用）判断鼠标在当前元素位置右下角时可拖拽
   * @param {object} canDragArea 限制鼠标拖拽的区域
   * @returns {void}
   */
  dragStartWithButton(canDragArea) {
    const { borderHeight, x, y, computeTiteHeight } = canDragArea;
    this.target.forEach((targetItem, index) => {
      targetItem.addEventListener('mousedown', e => {
        e = event || ev;
        this.startY = e.clientY;
        if (document.setCapture) document.setCapture();
        if (window.captureEvents) window.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP);
        if (targetItem.setCapture) {
          targetItem.setCapture();
        }
        document.onselectstart = function() {
          return false;
        }; //解决拖动会选中文字的问题
        document.ondragstart = function() {
          return false;
        };
        this.targetBeforeMoveHeight = 0;
        const timer = setTimeout(() => {
          // 解决重复触发问题
          this.mouseDownCount++;
          if (this.mouseDownCount > 1) {
            // const timer = setTimeout(() => {
            //   this.mouseDownCount = 0;
            //   clearTimeout(timer);
            // }, 2000);
            return;
          }
          // 这里定时器的原因是纸张也绑定了mousedown事件 为了纸张的事件先执行
          this.currentExistHeight = this.computedCurrentExistHeightWhenMD(this.target, index);
          this.setCurrentIndexInPages(index); // 设置当前在总页面的拖拽下标
          const titleHeight = computeTiteHeight(targetItem);
          this.currentTarget = targetItem;
          // const mytoolbarbox = $('.' + e.target.className.split(' ')[0]).closest(
          //   '.edui-editor-toolbarbox'
          // );
          // if (e.target.className && mytoolbarbox && mytoolbarbox.length > 0) {
          //   this.dragEnd(); // 先注释这块会导致点击数学函数操作影响高度变化 暂时没想起这段代码的意义
          // }
          if (targetItem.querySelector('.drag_mark')) {
            const inDragArea =
              calcOffsetXFromParent(e) > targetItem.offsetWidth - borderHeight * 2 - 100 - x &&
              calcOffsetYFromParent(e) >
                targetItem.offsetHeight - borderHeight * 2 - 100 - y - titleHeight; // 判断当前鼠标在拖拽器上面
            if (inDragArea) {
              this.options.callbacks.mouseDown(index);
              this.targetBeforeMoveHeight = targetItem.offsetHeight;
              console.log('鼠标按下多少次', this.mouseDownCount, e.clientY, targetItem);
              this.startX = calcOffsetXFromParent(e);
              // this.startY = calcOffsetYFromParent(e);
              this.onmousemove(targetItem);
              this.dragEnd();
            } else {
              this.mouseDownCount = 0;
            }
          } else {
            this.mouseDownCount = 0;
          }
          // const inDragArea =
          //   e.offsetX > targetItem.offsetWidth - borderHeight * 2 - 100 - x &&
          //   e.offsetY > targetItem.offsetHeight - borderHeight * 2 - 100 - y - titleHeight; // 判断当前鼠标在拖拽器上面
          clearTimeout(timer);
          return;
          if (inDragArea) {
            this.targetBeforeMoveHeight = targetItem.offsetHeight;
            this.startX = e.offsetX;
            this.startY = e.clientY;
            this.onmousemove(targetItem);
          }
        });
      });
      targetItem.addEventListener('mouseenter', e => {
        const timer = setTimeout(() => {
          this.setCurrentIndexInPages(index); // 设置当前在总页面的拖拽下标
          clearTimeout(timer);
        });
      });
    });
  }

  setCurrentIndexInPages(currentIndexInPages) {
    this.currentIndexInPages = currentIndexInPages;
  }

  /**
   * 鼠标移动
   * @param {Element} 当前鼠标所在元素
   * @returns {void}
   */
  onmousemove(target) {
    document.onmousemove = e => {
        e = event || ev;
        e.stopPropagation();
        e.preventDefault();
        
        this.moveY = e.clientY;
        this.moveY - this.startY > 0 ? (this.moveDirection = 'down') : (this.moveDirection = 'up');
        this.moveDistance = e.clientY - this.startY;
        
        const iframe = target.getElementsByTagName('iframe')[0];
        let realHeightAfterEdit = 0;
        const elements = (iframe && iframe.contentWindow.document.body.childNodes) || [];
        realHeightAfterEdit = this.getImageNodeHeight(elements, realHeightAfterEdit, []);
        
        const isChooseTopic =
            (target.className && target.className.indexOf(CHOOSE_CONT_CLASS) != -1) || false;
        let minDistance = realHeightAfterEdit + (isChooseTopic ? MARGIN_BOTTOM * 2 : 0);
        
        // 计算新高度（未限制）
        let newHeight = this.targetBeforeMoveHeight + this.moveDistance;
        console.log('onmousemove onmousemove::::', target);
        // 添加最大高度限制
        const isNonAnswer = (target.className && target.className.indexOf(NONANSWER_CLASS) != -1) || false;
        if (isNonAnswer && this.canFillHeight  && this.canFillHeight !== undefined && newHeight > this.canFillHeight) {
            newHeight = this.canFillHeight;
            if (this.moveDirection === 'down') {
                return;
            }
        }

        newHeight = Math.max(
            newHeight,
            minDistance + MARGIN_BOTTOM * 2
        );
        
        // 应用计算后的高度
        target.style.height = newHeight + 'px';
        
        // 更新拖拽元素的数据height（initDragHeight）
        this.options.callbacks.updateCurrentStackInitDragHeight(
            newHeight,
            this.currentIndexInPages
        );
        
        // 最小高度限制相关逻辑
        if (
            newHeight <= minDistance + MARGIN_BOTTOM * 2 &&
            this.moveDirection == 'up'
        ) {
            if (this.moveMinDistance) {
                // 鼠标移动到最小距离时 移动的距离停止 记录当前移动的距离
                this.isGetMinDistance = true;
            } else {
                this.moveMinDistance = e.clientY - this.startY;
                this.isGetMinDistance = false;
            }
            this.cacheClientY == 0 && (this.cacheClientY = e.clientY);
        }
    };
}

  /**
   *获取编辑器里面带有image的绝对定位的top值 然后比较累加的元素高度大小进行赋值
   * @param {Element} elements
   * @param {number} realHeightAfterEdit 编辑框里面的元素
   *
   */
  getImageNodeHeight(elements, realHeightAfterEdit, imageHeights) {
    if (elements && Array.from(elements) && Array.from(elements).length) {
      Array.from(elements).forEach((element, index) => {
        if (element.tagName == TAG_NAME_TABLE) {
          realHeightAfterEdit += element.offsetHeight + MARGIN_BOTTOM || 0;
        } else if (element.tagName == 'IMG' && element.style.position == 'absolute') {
          // top值是带px的string 替换成number类型
          let myRealHeightAfterEdit =
            (element.style.top &&
              Number(element.style.top.replace(/px/, '')) + element.offsetHeight) ||
            0;
          imageHeights.push(myRealHeightAfterEdit);
          // realHeightAfterEdit =
          //   realHeightAfterEdit > myRealHeightAfterEdit
          //     ? realHeightAfterEdit
          //     : myRealHeightAfterEdit;
          // 存在一个标签里面不同层级的element里面有image标签，所以要判断 image绝对定位的top值的大小
        } else {
          realHeightAfterEdit += element.offsetHeight || 0;
        }
        this.getImageNodeHeight(element.children, realHeightAfterEdit, imageHeights);
      });
    }
    imageHeights.forEach(height => {
      if (height > realHeightAfterEdit) {
        realHeightAfterEdit = height;
      }
    });
    return realHeightAfterEdit;
  }

  /**
   * 鼠标抬起 拖拽结束
   * @returns {void}
   */
  dragEnd() {
    // 全局文档取消鼠标move事件
    document.onmouseup = e => {
      //里面嵌套的iframe 所以里面的鼠标抬起事件失效了
      // 鼠标抬起和鼠标向上停止冲突了 导致拖拽失败
      e = event || ev;
      e.stopPropagation();
      document.onmousemove = null;
      document.onmouseup = null;
      this.mouseDownCount = 0;
      // document.onmouseup = null;
      try {
        if (document.releaseCapture) document.releaseCapture();
        if (window.releaseEvents) window.releaseEvents(Event.MOUSEMOVE | Event.MOUSEUP);
      } catch (e) {
        this.options.callbacks.mouseUp();
        console.log('鼠标mouseup报错', e.message);
      }
      // if (document.releaseCapture) this.releaseCapture();
      // if (window.releaseEvents) window.releaseEvents(Event.MOUSEMOVE | Event.MOUSEUP);
      // this.isMinDistance(this.this.currentTarget[0]);
      this.moveDistance = this.moveMinDistance ? this.moveMinDistance : e.clientY - this.startY;
      if (Math.abs(this.moveDistance) <= 10) {
        // 如果移动的距离小于10 则不作处理
        this.moveDistance = 0;
      }
      console.log(
        '鼠标抬起了',
        `起始startY的值${this.startY},抬起的Y值${e.clientY}移动的距离${this.moveDistance}是否移动到最小min距离${this.moveMinDistance}`
      );

      if (this.startY === 0) {
        // 这代表鼠标点击的时候不是在拖拽器上面 是在其他的区域
        this.options.callbacks.mouseUp();
        // return;
      }
      // this.moveDistance && (this.moveDistance = e.clientY - this.startY);
      // debugger; // 这里有bug
      if (this.moveDistance < 0 || this.isGetMinDistance) {
        // if (this.moveDistance < 0 && this.cacheClientY != 0) {
        // 这里|| 改成&&可能存在问题 先这样处理
        // 拖拽没有到达最大高度
        try {
          this.moveDistance &&
            this.options.callbacks.copyDragHeightToInitDragHeight(
              this.currentTarget.offsetHeight,
              this.currentIndexInPages
            );

          if (this.moveDistance || this.cacheClientY != 0) {
            this.dragUp(
              this.currentTarget,
              this.moveDistance,
              this.hasNextPageCell(),
              this.currentIndexInPages,
              e,
              this.targetBeforeMoveHeight,
              { cacheClientY: this.cacheClientY } // 缓存最小高度时候 继续向上拖拽 如果有值且不为0则代表可以删除当前元素
            );
          }
          this.isGetMinDistance = false;
        } catch (e) {
          this.isGetMinDistance = false;
          console.error('拖拽抬起报错', this.currentTarget, e.message);
        }
        this.moveDistance = 0;
        this.cacheClientY = 0;
        // return;
      } else if (this.moveDistance === 0) {
        this.options.callbacks.mouseUp();
        this.moveMinDistance = 0;
        this.cacheClientY = 0;
        return;
      }

      // const timer = setTimeout(() => {
      this.moveDistance &&
        this.options.callbacks.updateCurrentStackInitDragHeight(this.currentIndexInPages); // 及时更新拖拽元素的数据height（initDragHeight）
      // clearTimeout(timer);
      // }, 220);
      // if (this.moveDistance == 0) {
      //   // 判断鼠标抬起之前是否有move操作
      //   this.moveDistance = 0;
      //   return;
      // }
      //this.isMaxDistance(this.currentTarget, e);
      const hasNextPage = this.hasNextPageCell(); // 判断当前鼠标所在是否有下一页（是否最后一页）
      this.moveDirection == 'down' &&
        this.options.callbacks.dragDown(
          this.currentTarget,
          this.moveDistance,
          this.currentIndexInPages,
          hasNextPage
        ); // 鼠标拖拽超过部分去除 填满之前的高度
      this.moveDistance = 0;
      this.startY = 0;
      this.moveY = 0;
      this.options.callbacks.mouseUp();
      this.moveMinDistance = 0;
    };
  }

  /**
   * 判断移动是否到最大距离
   */
  isMaxDistance(target, dragEndEvent) {
    const endDistance = dragEndEvent.clientY - this.startY;
    // const currentDragRelativeElement = target.parentNode.parentNode; // 当前拖拽的参考元素 就是最外层的 wrapper-content
    const currentVisibleMaxHeight = target.parentNode.parentNode.parentNode.offsetHeight; // 当前页纸张最大高度
    // 预留20px提示用户换页 marginTop值10 border 上下1px 2
    if (this.currentExistHeight + endDistance + 2 >= currentVisibleMaxHeight) {
      const hasNextPage = this.hasNextPageCell(); // 判断当前鼠标所在是否有下一页（是否最后一页）
      const overstepDistance = this.overstepComputed(endDistance, currentVisibleMaxHeight); // 计算超过的高度
      this.options.callbacks.dragDown(
        target,
        overstepDistance,
        this.currentIndexInPages,
        hasNextPage
      ); // 鼠标拖拽超过部分去除 填满之前的高度
      // setTimeout(() => {
      //   this.options.callbacks.updateViewHeight();
      // }, 100);
    } else {
      // 拖拽没有到达最大高度
      this.options.callbacks.copyDragHeightToInitDragHeight(
        target.offsetHeight,
        this.currentIndexInPages
      );
    }
  }

  /**
   * 判断移动是否最小距离
   */
  isMinDistance(target, moveDistance) {
    const iframe = target.getElementsByTagName('iframe')[0];
    let newHurdle = undefined;
    let editorContentHasPTagNums =
      (iframe && iframe.contentWindow.document.getElementsByTagName('p')) || [];
    let minDistance = editorContentHasPTagNums.length * TAG_P_HEIGHT; // 当前p标签固定高度*p标签集合的长度
    const brTagList =
      editorContentHasPTagNums[0] && editorContentHasPTagNums[0].getElementsByTagName('br'); // 当前p标签下是否含有br标签
    if (editorContentHasPTagNums.length <= 1 && (brTagList && brTagList.length) !== 0) {
      newHurdle = true;
    } else {
      newHurdle = false;
    }
    if (newHurdle) {
      // 如果是新生成的跨栏里面也会包含一个只有br标签的p标签
      minDistance = 0;
    }
    // 预留20px提示用户换页 marginTop值10 border 上下1px 2
    if (moveDistance <= minDistance + 20) {
      this.moveDistance = minDistance;
      return true;
    }
    return false;
  }

  /**
   *
   * @param {*} moveDistance
   * @param {*} hasNextPage
   * @param {Element} target
   * @param {Event} e
   * @param {*} currentIndexInPages
   */
  dragUp(
    target,
    moveDistance,
    hasNextPage,
    currentIndexInPages,
    e,
    targetBeforeMoveHeight,
    dragOption
  ) {
    this.options.callbacks.dragUp(
      target,
      moveDistance,
      hasNextPage,
      currentIndexInPages,
      e,
      targetBeforeMoveHeight,
      dragOption
    );
  }

  /**
   * 鼠标移动超出最大高度的距离（超出部分）
   * @returns {number} overstepDistance 超出距离
   */
  overstepComputed(endDistance, currentVisibleMaxHeight) {
    const MARGIN_TOP_NUMS =
      state.pageCell[state.currentPageNum] &&
      state.pageCell[state.currentPageNum].fillTopiclist.length;
    const overstepDistance =
      this.currentExistHeight +
      endDistance +
      BORDER_HEIGHT * MARGIN_TOP_NUMS -
      // MARGIN_TOP * MARGIN_TOP_NUMS
      currentVisibleMaxHeight;
    this.overstepDistance = overstepDistance;
    // debugger;
    return overstepDistance;
  }

  /**
   * 拖拽计算可视区局最大高度
   */
  computedCurrentMaxHeightwithMouseMove(target) {
    // 当前页纸张内容的累加高度
    const currentVisibleMHeight = target.parentNode;
  }

  /**
   * 鼠标按下计算已经存下的元素累加高度
   * @param {Array<Element>} target 当前纸张已经存在的题型元素
   * @returns {number} 返回已经存下的元素累加高度
   */
  computedCurrentExistHeightWhenMD(target) {
    const state = this.store.state.card;
    const { currentPageNum } = state;
    const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[currentPageNum]; // 鼠标旨在当前的纸张下标
    const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
    let currentExistHeight = 0;
    topicBoxElements.forEach(targetItem => {
      currentExistHeight += targetItem.offsetHeight;
    });
    return currentExistHeight;
  }

  /**
   * 当前鼠标所在页面是否为最后一页
   * @returns {boolean}
   */
  hasNextPageCell() {
    const state = this.store.state.card;
    const { currentPageNum, pageCell } = state;
    return currentPageNum < pageCell.length - 1;
  }
}
